"use strict";

var options = ["Attitude / Personal Growth", "Career / Education", "Citizenship / Giving back", "Finance", "Health / Wellbeing", "Family", "Friendships / Relationships", "Social Life", "Spirituality"];
var questions = [{
  prompt: "",
  extraText: "What are the most important areas of your life? (you can select multiple options)",
  type: "multiselect",
  options: options
}, {
  prompt: "",
  extraText: "You selected __content__ as important to you. Write down at least one thing you could do in one of these areas below.",
  type: "single",
  placeholder: "E.g. Read to my daughter, join an art class, etc.",
  options: options
}];

var analysis = function analysis(answers) {
  return {
    "important areas of my life": answers[0].map(function (a) {
      return options[a];
    }).join(", "),
    action: answers[1]
  };
};

module.exports = {
  questions: questions,
  analysis: analysis
};